import {registration} from 'backend/auth';
import {local} from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {
	
});

// export function registration_click(event) {
// 	let name = $w('#name').value;
// 	let last = $w('#last').value;
// 	let email = $w('#email').value;
// 	let phone = $w('#phone').value;
// 	let city = $w('#city').value;
// 	let password = $w('#password').value;
// 	let password2 = $w('#password2').value;

// 	if (password === password2) {
// 		registration(name, last, email, phone, city, password).then(response => {
// 			// console.log(product);
// 			let user = JSON.stringify(response);
// 			local.setItem("user", user);
// 			wixLocation.to('/lawyerplatform-home');
// 		})
// 		.catch(error => {
// 			console.log(error);
// 		});
// 	} else {
// 		$w('#error').text = 'Паролите не съвпадат';
// 		$w('#error').expand();
// 	}
// }